<template>
  <div class="video-container" @click="handlePlayVideo">
    <van-icon name="video" color="#666" size="1.5em" />
    <div class="help-text">帮助</div>
  </div>

</template>

<script>
  import { Popup } from 'vant';
  export default {
    name: "HelpVideo",
    data() {
      return {
        visible: false
      }
    },
    methods: {
      handlePlayVideo() {
        this.$router.push({
          path: '/mobile/help'
        })
      }
    }
  }
</script>

<style lang="scss" scoped>

  .video-container {
    z-index: 2;
    position: fixed;
    right: 0.5rem;
    bottom: 1rem;
    width: 1.1rem;
    height: 1.1rem;
    box-shadow: 0px 2px 7px 0px #BAC8E0;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .help-text {
      color: #666;
      font-size: 0.22rem;
      margin-top: 0.04rem;
    }
  }
</style>
